import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { directoryApi } from '@/api/directoryApi'

const LONG = 5 * 60_000

export function useCustomers(enabled = true) {
  return useQuery({ queryKey: ['customers'], queryFn: directoryApi.customers, enabled, staleTime: LONG })
}

export function useContacts(customerId: string | null | undefined) {
  return useQuery({
    queryKey: ['contacts', customerId],
    queryFn: () => directoryApi.contacts(customerId as string),
    enabled: Boolean(customerId),
    staleTime: LONG,
  })
}

export function useProducts(enabled = true) {
  return useQuery({ queryKey: ['products'], queryFn: directoryApi.products, enabled, staleTime: LONG })
}

export function useAgents(enabled = true) {
  return useQuery({ queryKey: ['agents'], queryFn: directoryApi.agents, enabled, staleTime: LONG })
}

/** Sets a contact's name / role; refreshes that customer's contact list. */
export function useUpdateContact() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: { name?: string; role?: string } }) => directoryApi.updateContact(id, input),
    onSuccess: (contact) => void queryClient.invalidateQueries({ queryKey: ['contacts', contact.customerId] }),
  })
}
